import React from 'react'
import './Programs.css'
import { programsData } from '../../data/programsData';
import RightArrow from '../../assets/rightArrow.png'

const Programs = () => {
  return (
    <section className="programs" id='programs'>
      <div className='programs-header'>
        <h2 className='stroke-text'>Explore Our</h2>
        <h2 className='outfit'>Training Programs</h2>
        <h2 className='stroke-text'>To Reach Your Goals</h2>
      </div>

      <div className="program-categories">
        {programsData.map((program, i) => (
          <div className="program-card glass-card" key={i}>
            <div className="card-bg" style={{ backgroundImage: `url(${program.image_background})` }}></div>
            <div className="card-content">
              <div className="program-icon">
                {program.image}
              </div>
              <h3 className="outfit">{program.heading}</h3>
              <p>{program.details}</p>
              <a href="tel:+9779863032963" className="join-btn">
                <span>Join Now</span>
                <img src={RightArrow} alt="arrow" />
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default Programs